import React from "react";
import PropTypes from "prop-types";
import Select from "react-select";

const StatusSelect = ({ value: initialValue, onChange }) => {
  const options = [
    { label: "Active", value: true },
    { label: "Inactive", value: false }
  ];

  return (
    <Select
      id="status-select"
      name="status"
      className="react-select-container"
      classNamePrefix="react-select-container"
      fullwidth
      placeholder="Status"
      value={initialValue}
      options={options}
      isClearable
      onChange={onChange}
    />
  );
};

StatusSelect.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func
};

export default StatusSelect;
